import React from "react";
import LegalPageShell from "../components/LegalPageShell";

/**
 * Cookie Policy hostata da Iubenda — embed via iframe.
 */
export default function CookiePolicy() {
  return (
    <LegalPageShell
      title="Cookie Policy"
      subtitle="Informativa sull'uso dei cookie ai sensi della normativa italiana ed europea (GDPR + Direttiva ePrivacy). Aggiornata e generata tramite Iubenda."
      testid="page-cookie-policy"
    >
      <div className="rounded-3xl border border-[var(--mp-ink)] bg-white shadow-brutal-sm overflow-hidden">
        <iframe
          src="https://www.iubenda.com/privacy-policy/22650933/cookie-policy"
          title="Cookie Policy"
          data-testid="iubenda-cookie-iframe"
          className="w-full"
          style={{ height: "1600px", border: "0" }}
        />
      </div>
      <div className="mt-6 text-sm text-[var(--mp-muted)]">
        Documento ospitato da Iubenda. Per modificare le tue preferenze sui
        cookie usa il pulsante{" "}
        <button
          type="button"
          onClick={() => {
            if (window._iub && window._iub.cs && window._iub.cs.api) {
              window._iub.cs.api.openPreferences();
            }
          }}
          className="underline hover:text-[var(--mp-ink)] cursor-pointer bg-transparent border-0 p-0"
          data-testid="cookie-policy-open-prefs"
        >
          "Preferenze cookie"
        </button>{" "}
        nel footer, oppure{" "}
        <a
          href="https://www.iubenda.com/privacy-policy/22650933/cookie-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-[var(--mp-ink)]"
          data-testid="cookie-policy-fallback-link"
        >
          apri la Cookie Policy in una nuova scheda
        </a>
        .
      </div>
    </LegalPageShell>
  );
}
